import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { DevAlert } from '../index';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { useDispatch } from 'react-redux';
import { sort } from '../../store/reducers/volunteersService';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

export default function ContainedButtons() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [devAlert, setDevAlert] = useState(false);
  const [sortedByLastName, setSorterByLastName] = useState(false);
  const [sortedByLastNameIcon, setSorterByLastNameIcon] = useState(false);
  const [sortedByFillingDate, setSorterByFillingDate] = useState(false);
  const [sortedByFillingDateIcon, setSorterByFillingDateIcon] = useState(true);
  const [sortedByHours, setSorterByHours] = useState(false);
  const [sortedByHoursIcon, setSorterByHoursIcon] = useState(false);

  return (
    <div className={classes.root}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          dispatch(
            sort({
              sortedByDesc: sortedByFillingDate ? false : true,
              key: 'fillingDate',
              areHours: false,
              areDates: true,
            })
          );
          setSorterByFillingDate(sortedByFillingDate ? false : true);
          setSorterByLastNameIcon(false);
          setSorterByFillingDateIcon(true);
          setSorterByHoursIcon(false);
        }}
      >
        {sortedByFillingDateIcon &&
          (sortedByFillingDate ? (
            <ArrowDownwardIcon style={{ marginRight: '3px' }} />
          ) : (
            <ArrowUpwardIcon style={{ marginRight: '3px' }} />
          ))}
        По дате добавления
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          dispatch(
            sort({
              sortedByDesc: sortedByLastName ? false : true,
              key: 'lastName',
              areHours: false,
              areDates: false,
            })
          );
          setSorterByLastName(sortedByLastName ? false : true);
          setSorterByLastNameIcon(true);
          setSorterByFillingDateIcon(false);
          setSorterByHoursIcon(false);
        }}
      >
        {sortedByLastNameIcon &&
          (sortedByLastName ? (
            <ArrowDownwardIcon style={{ marginRight: '3px' }} />
          ) : (
            <ArrowUpwardIcon style={{ marginRight: '3px' }} />
          ))}
        По фамилиям
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          dispatch(
            sort({
              sortedByDesc: sortedByHours ? false : true,
              key: 'workingHoursPerMonth',
              areHours: true,
              areDates: false,
            })
          );
          setSorterByHours(sortedByHours ? false : true);
          setSorterByLastNameIcon(false);
          setSorterByFillingDateIcon(false);
          setSorterByHoursIcon(true);
        }}
      >
        {sortedByHoursIcon &&
          (sortedByHours ? (
            <ArrowDownwardIcon style={{ marginRight: '3px' }} />
          ) : (
            <ArrowUpwardIcon style={{ marginRight: '3px' }} />
          ))}
        По количеству часов
      </Button>
      <DevAlert isOpen={devAlert} callBack={() => setDevAlert(false)} />
    </div>
  );
}
